var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"left"}},[_vm._v("辅料商品SKU:"+_vm._s(this.query.shopProductSku))]),_c('WmsTable',{attrs:{"columns":_vm.columnsOperationData,"dataSource":_vm.datasource,"isPagination":_vm.query},on:{"pageChange":_vm.pageChangeCall}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }